module.exports = __webpack_public_path__ + "img/instagram.21c02fda.svg";